import { home } from '@/lang/de/pages/home.ts'
import { pricing } from '@/lang/de/pages/pricing.ts'
import { avg } from '@/lang/de/pages/avg.ts'
import { agents } from '@/lang/de/pages/campaigns/agents.ts'
import { gloriafood } from '@/lang/de/pages/campaigns/gloriafood.ts'

import { manager } from '@/lang/de/pages/products/manager.ts'
import { page } from '@/lang/de/pages/products/page.ts'
import { pos } from '@/lang/de/pages/products/pos.ts'
import { posdevice } from '@/lang/de/pages/products/posdevice.ts'
import { qr } from '@/lang/de/pages/products/qr.ts'
import { webshop } from '@/lang/de/pages/products/webshop.ts'
import { kiosk } from '@/lang/de/pages/products/kiosk.ts'

import { lunchroom } from '@/lang/de/pages/cases/lunchroom.ts'
import { cafetaria } from '@/lang/de/pages/cases/cafetaria.ts'
import { grillroom } from '@/lang/de/pages/cases/grillroom.ts'
import { sushi } from '@/lang/de/pages/cases/sushi.ts'
import { italian } from '@/lang/de/pages/cases/italian.ts'

import { support } from '@/lang/de/pages/info/support.ts'
import { faq } from '@/lang/de/pages/info/faq.ts'
import { downloads } from '@/lang/de/pages/info/downloads.ts'
import { integrations } from '@/lang/de/pages/info/integrations.ts'
import { terms } from '@/lang/de/pages/info/terms.ts'
import { google } from '@/lang/de/pages/integrations/google.ts'
import { facebook } from '@/lang/de/pages/integrations/facebook.ts'
import { instagram } from '@/lang/de/pages/integrations/instagram.ts'
import { mollie } from '@/lang/de/pages/integrations/mollie.ts'
import { stripe } from '@/lang/de/pages/integrations/stripe.ts'
import { lightspeed } from '@/lang/de/pages/integrations/lightspeed.ts'
import { exactonline } from '@/lang/de/pages/integrations/exactonline.ts'
import { mpluskassa } from '@/lang/de/pages/integrations/mpluskassa.ts'
import { twilio } from '@/lang/de/pages/integrations/twilio.ts'
import { winstonpos } from '@/lang/de/pages/integrations/winstonpos.ts'
import { untill } from '@/lang/de/pages/integrations/untill.ts'
import { leat } from '@/lang/de/pages/integrations/leat.ts'
import { slack } from '@/lang/de/pages/integrations/slack.ts'
import { cashdesk } from '@/lang/de/pages/integrations/cashdesk.ts'

export const pages = {
  home,
  campaigns: {
    agents,
    gloriafood,
  },
  agents,
  avg,
  products: {
    manager,
    page,
    pos,
    posdevice,
    qr,
    webshop,
    kiosk,
  },
  pricing,
  cases: {
    lunchroom,
    cafetaria,
    grillroom,
    sushi,
    italian,
  },
  info: {
    support,
    faq,
    downloads,
    integrations,
    terms,
    integrations_detail: {
      google,
      facebook,
      instagram,
      mollie,
      stripe,
      lightspeed,
      exactonline,
      mpluskassa,
      twilio,
      winstonpos,
      untill,
      leat,
      slack,
      cashdesk,
    },
  },
}
